/* eslint-disable style/no-tabs */
import { useTranslation } from "react-i18next";

function SecurityFailedInvalidDocument() {
  const { t } = useTranslation("security");

  return (
    <>
      <p>
        {t("security:kyc-failed-invalid-document-intro")}
        {/* We regret to inform you that your recent submission for the verification
				process has been unsuccessful due to the submission of an invalid
				document. Your document has been reviewed and unfortunately, it does not
				meet the necessary requirements for verification. */}
      </p>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-invalid-document-header")}
        {/* The issues may include: */}
      </p>
      <div class="w-full h-4" />
      <p>
        <strong>
          {t("security:kyc-failed-invalid-document-list-header-1")}
          {" "}
          {/* Invalid Document: */}
        </strong>
        {t("security:kyc-failed-invalid-document-list-item-1")}
        {/* The document you submitted for verification does not meet our criteria
				for an acceptable document. This may include but is not limited to
				documents that are expired or do not match the document type requested
				for verification. */}
      </p>
      <p>
        {t("security:kyc-failed-invalid-document-instructions")}
        {/* To address this issue and proceed with your verification, please take
				the following steps: */}
      </p>
      <div class="w-full h-4" />
      <ul>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-invalid-document-list-header-2")}
            {" "}
            {/* Resubmit Valid Documentation: */}
          </strong>
          {t("security:kyc-failed-invalid-document-list-item-2-pt1")}
          {" "}
          {/* Ensure that you provide a valid and unaltered document that meets the
					requirements for verification. This may include a government-issued ID
					card, passport, driver's license, or any other document specified in */}
          <a
            href="https://knowledge-base.sentric.com/what-documents-are-accepted-by-idenfy"
            target="_blank"
            rel="noreferrer"
            title={t("security:kyc-failed-documents-link")} // 'What Documents Are Accepted By Idenfy?'
          >
            {t("security:kyc-failed-invalid-document-list-item-2-pt2")}
            {" "}
            {/* our guidelines */}
          </a>
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-invalid-document-list-header-3")}
            {" "}
            {/* Check Document Expiry: */}
          </strong>
          {t("security:kyc-failed-invalid-document-list-item-3")}
          {/* Ensure that the document you submit is currently valid and has not
					expired. Expired documents cannot be accepted for verification. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-invalid-document-list-header-4")}
            {" "}
            {/* Verify Document Authenticity: */}
          </strong>
          {t("security:kyc-failed-invalid-document-list-item-4")}
          {/* Make certain that the document is genuine, free from alterations, and
					matches the document type required for the process. */}
        </li>
      </ul>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-invalid-document-ending")}
        {/* We look forward to receiving valid documentation for your verification. */}
      </p>
    </>
  );
}

export default SecurityFailedInvalidDocument;
